import React from 'react';
import { FaEdit, FaTrash } from 'react-icons/fa';
const AobList = ({ items, removeItem, editItem }) => {
    return (
        <div className='aob-list'>
            {items.map((item) => {
                // Add null check before attempting to destructure item
                if (!item) return null;
                const { id, aob } = item;
                return (
                    <article className='aob-item' key={id}>
                        <p className='title'>{aob}</p>
                        <div className='btn-container'>
                            <button
                                type='button'
                                className='edit-btn'
                                onClick={() => editItem(id)}
                            >
                                <FaEdit />
                            </button>
                            <button
                                type='button'
                                className='delete-btn'
                                onClick={() => removeItem(id)}
                            >
                                <FaTrash />
                            </button>
                        </div>
                    </article>
                );
            })}
        </div>
    );
};

export default AobList;
